module.exports = __webpack_public_path__ + "static/media/Group46.2690e376.svg";